import React, { useState, useImperativeHandle, forwardRef } from 'react'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'

//images
import closeIcon from '../../../assets/images/profile/messages/close.png'
import testIcon from '../../../assets/images/profile/messages/test.png'
import btnTestIcon from '../../../assets/images/profile/messages/btn-test.png'

const initialState = {
    heading: '',
    description: '',
    url: '',
    button: ''
}
function VideosMessage(props, ref) {
    const [state, setState] = useState({
        blur: false,
        popup: false,
        ...initialState
    })

    useImperativeHandle(ref, () => ({
        open: (heading, description, url, button) => handleOpen(heading, description, url, button),
        close: () => handleClose()
    }))

    const handleOpen = (heading, description, url, button) => {
        setState(state => ({
            ...state,
            blur: true,
            heading,
            description,
            url,
            button
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={state.blur ? 'visible' : ''}>
            <div className={`box videos-message ${state.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                />
                <img src={testIcon} alt="test" className="main-img" />
                <h2>
                    {state.heading}
                </h2>
                <p>
                    {state.description}
                </p>
                <div className="buttons">
                    <Link to={state.url}>
                        <Button style={{ width: '320px' }}>
                            <img src={btnTestIcon} alt="video" />
                            Към въпросите от Тема {state.button}
                        </Button>
                    </Link>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(VideosMessage)